import React from "react";
import ColorSwatches from "./ColorSwatches";
// Preserve the existing compact workspace palette by default.
export default function Colors(props) {
  return <ColorSwatches columns={3} size={35} round {...props} />;
}
